import Wave from 'components/Animations/Wave/wave';
import { Button } from 'react-bootstrap';
import { AiFillApple, AiFillAndroid } from 'react-icons/ai';
import {
  BackgroundContainer,
  Container,
  Content,
  Inner,
  PulsingImage,
  PulsingImageArea,
} from './styled';

const DownloadArea = () => {
  return (
    <Container>
      <BackgroundContainer>
        <Wave />
      </BackgroundContainer>

      <Inner>
        <PulsingImageArea>
          <PulsingImage src={require('assets/animatingimgs/1.jpg')} />
          <PulsingImage src={require('assets/animatingimgs/2.jpg')} />
          <PulsingImage src={require('assets/animatingimgs/3.jpg')} />
          <PulsingImage src={require('assets/animatingimgs/4.jpg')} />
          <PulsingImage src={require('assets/animatingimgs/5.jpg')} />
          <PulsingImage src={require('assets/animatingimgs/6.jpg')} />
        </PulsingImageArea>

        <Content>
          <h2>Werde teil der Community!</h2>
          <div className="button-container">
            <a
              href="https://apps.apple.com/de/app/jobbrn/id1525126986"
              target="blank">
              <Button variant="outline-dark">
                <AiFillApple />
                Apple Store
              </Button>
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.jobbrn.jobbrn"
              target="blank">
              <Button variant="outline-dark">
                <AiFillAndroid />
                Google Play
              </Button>
            </a>
          </div>
          <p>
            Hol dir jetzt die Jobbrn App und erlebe einfache und nachhaltige
            Unterstützung im Alltag.
          </p>
        </Content>
      </Inner>
    </Container>
  );
};

export default DownloadArea;
